/* ═══════════════════════════════════════════════════
   TrackLab v2 — Venue Filtering (Upcoming Page)
   ═══════════════════════════════════════════════════ */

(function () {
  'use strict';

  TL.venue = {};

  // Cache the original best-strip HTML so we can restore it on "All Races"
  var _defaultPicksHTML = '';
  var picksEl = document.getElementById('v2BestPicks');
  if (picksEl) _defaultPicksHTML = picksEl.innerHTML;

  TL.venue.filter = function (btn) {
    // Only the course strip's own tabs: the Next to run / By course view toggle
    // above it also uses .v2-vf-tab and must keep its selected tab (team#144).
    var strip = btn.closest('#v2VenueFilters') || btn.parentElement || document;
    strip.querySelectorAll('.v2-vf-tab[data-venue]').forEach(function (t) { t.classList.remove('on'); });
    btn.classList.add('on');

    var venue = btn.dataset.venue;
    var groups = document.querySelectorAll('.meeting[data-venue]');

    if (venue === 'all') {
      groups.forEach(function (g) { g.style.display = ''; });
    } else {
      groups.forEach(function (g) {
        g.style.display = g.dataset.venue === venue ? '' : 'none';
      });
    }

    // Update best-strip: show all picks or single venue best pick
    TL.venue._updateBestStrip(venue);

    // Update meeting summary text
    var summaryEl = document.getElementById('v2MeetingSummary');
    if (summaryEl) {
      if (venue === 'all') {
        summaryEl.textContent = summaryEl.getAttribute('data-all');
      } else {
        var jsonEl = document.getElementById('v2VenueSummaries');
        if (jsonEl) {
          try {
            var summaries = JSON.parse(jsonEl.textContent);
            summaryEl.textContent = summaries[venue] || summaryEl.getAttribute('data-all');
          } catch (e) { /* fall back to all */ }
        }
      }
    }
  };

  TL.venue._updateBestStrip = function (venue) {
    var strip = document.getElementById('v2BestStrip');
    var picksContainer = document.getElementById('v2BestPicks');
    if (!strip || !picksContainer) return;

    var labelEl = strip.querySelector('.bs-label');

    if (venue === 'all') {
      // Restore original top 3
      picksContainer.innerHTML = _defaultPicksHTML;
      if (labelEl) labelEl.textContent = strip.dataset.defaultLabel || "Today's Best";
      return;
    }

    // Load per-venue picks
    var jsonEl = document.getElementById('v2BestPicksByVenue');
    if (!jsonEl) return;

    var byVenue;
    try { byVenue = JSON.parse(jsonEl.textContent); } catch (e) { return; }

    var pick = byVenue[venue];
    if (!pick) {
      picksContainer.innerHTML = '<div style="font-size:12px;color:var(--text-muted);">No scored picks for this meeting</div>';
      if (labelEl) labelEl.textContent = venue + ' Best';
      return;
    }

    // Build single pick card
    var silkInner = pick.silk_url
      ? '<img src="' + pick.silk_url + '" alt="" style="width:100%;height:100%;border-radius:6px;">'
      : (pick.cloth_number || '');
    var silkStyle = pick.silk_url ? '' : ' style="background:' + (pick.silk_color || 'var(--accent-blue)') + ';"';

    var detail = pick.venue_name + ' \u00b7 ' + pick.race_time;
    if (pick.odds) detail += ' \u00b7 ' + (pick.odds === '1/1' ? 'Evens' : pick.odds);

    picksContainer.innerHTML =
      '<div class="bs-pick" onclick="v2ToggleUpcomingRace(\'' + pick.race_id + '\')">' +
        '<div class="bsp-silk"' + silkStyle + '>' + silkInner + '</div>' +
        '<div class="bsp-info">' +
          '<div class="bsp-name"></div>' +
          '<div class="bsp-detail"></div>' +
        '</div>' +
        '<div class="bsp-score"></div>' +
      '</div>';

    // Use textContent to avoid XSS
    var card = picksContainer.querySelector('.bs-pick');
    card.querySelector('.bsp-name').textContent = pick.horse_name;
    card.querySelector('.bsp-detail').textContent = detail;
    var scoreEl = card.querySelector('.bsp-score');
    scoreEl.textContent = TL.scorePct(pick.score);
    ['top', 'great', 'good', 'mid', 'low'].forEach(function (t) { scoreEl.classList.remove('s-' + t); });
    scoreEl.classList.add(TL.scoreTierClass(pick.score));
    scoreEl.dataset.score = String(pick.score);

    if (labelEl) labelEl.textContent = venue + ' Best';
  };
})();
